export default {
  PRODUCT_SEARCH: 'PRODUCT_SEARCH',
  ARTICLE_NUMBER_IMPORT: 'ARTICLE_NUMBER_IMPORT',
  PLACEHOLDER: 'PLACEHOLDER',
  BAR_LIST: 'BAR_LIST',
};
